import React from 'react';

const Library = () => {
  return (
    <div>Library</div>
  );
};

export default Library;
